import React, { useState, useEffect, useRef } from 'react'
import {Row,Col,Form} from 'react-bootstrap'
import {Link} from 'react-router-dom'
import Card from '../../../components/Card'
import { API_REMARK_STATUS_LIST, API_REMARK_STATUS_DELETE } from '../../../service/url';
import { getApiCall, deleteApiCallWithHeader } from '../../../service/httpCall';
import { DataTable } from 'primereact/datatable';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import RenderDeleteModal from '../../../components/partials/components/delete-modal';
import ToastNotification from '../../../components/Toast';
import { toast } from 'react-toastify';
import { ROUTES, MODULE_ACL, USER_ROLES } from '../../../utilities/constant';
import { exportToCSV, hasPermission } from '../../../utilities/helpers';
import Loader  from '../../../components/partials/components/loader';
import { useNavigate } from "react-router-dom";
import { useAuth, errorCheck } from '../auth/auth-utils';
import { EditIcon, DeleteIcon } from '../../../components/setting/elements';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';
import "../../../assets/custom/css/custom.css";
import { postApiCall} from "../../../service/httpCall";
import exportData from '../../../utilities/export';
import { getUser } from "../../../utilities/setting";


//theme
import 'primereact/resources/themes/lara-light-indigo/theme.css';
//core
import 'primereact/resources/primereact.min.css';

const RemarkStatusList = () =>{
   const navigate = useNavigate();
   const { checkAuth } = useAuth();
   const [remarkStatusList, setRemarkStatusList] = useState([]);
   const [enableDeleteModal, setEnableDeleteModal] = useState(false);
   const [confirmDelete, setConfirmDelete] = useState(false);
   const [deleteRemarkStatusId, setDeleteRemarkStatusId] = useState(undefined);
   const [showToast, setShowToast] = useState(false);
   const [toastProps, setToastProps] = useState(null);
   const [loading, setLoading] = useState(false);
   const [selectedRemarkStatus, setSelectedRemarkStatus] = useState([]);
   const [isMultiDelete, setIsMultiDelete] = useState(false);
   const [buttonDisable, setButtonDisable] = useState(false);

   const [searchValue, setSearchValue] = useState(null);
   const [originalDataList, setOriginalDataList] = useState([]);
   const [loggedInUserACL, setLoggedInUserACL] = useState({})
   const [isSuperAdmin, setIsSuperadmin] = useState(false)

   const handleExport = async () => {
   try {
      setButtonDisable(true);

      exportToCSV({
         fileName: "remark-status-list",
         data: remarkStatusList,
         columns: [
            {
               header: "Remark",
               accessor: "remark"
            },
            {
               header: "Status",
               accessor: "status"
            },
            {
               header: "Created Date",
               accessor: (row) =>
                  new Date(row.created_at).toLocaleString(
                     "en-IN",
                     {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                     }
                  )
            },
            {
               header: "Created By",
               accessor: (row) =>
                  row.created_by_user?.username || "-"
            }
         ]
      });

   } finally {
      setButtonDisable(false);
   }
};
  
    const handleCheckboxToggle = (aclId) => {
      const isSelected = selectedRemarkStatus.includes(aclId);
      setSelectedRemarkStatus(isSelected
          ? selectedRemarkStatus.filter(id => id !== aclId)
          : [...selectedRemarkStatus, aclId]);
    };
  
    const handleMultiDelete = () => {
          setIsMultiDelete(true);
          setEnableDeleteModal(true);
    };


   // useEffect( () => {
   //    if(toastProps){
   //       setShowToast(true);
   //    }
   // }, [toastProps]);

   useEffect(() => {
      setLoading(true);
      const user = getUser();
         if (user.role === USER_ROLES.SUPERADMIN) {
            setIsSuperadmin(true);
         }
         if (user?.acl_settings) {
            setLoggedInUserACL(JSON.parse(user.acl_settings.module_operations));
         }
      getApiCall(API_REMARK_STATUS_LIST)
          .then(onRemarkStatusListSuccess)
          .catch(onError)
          .finally(() => setLoading(false));

  }, []);

   
   function onRemarkStatusListSuccess(resp){
      const updatedList = resp.map( (val, idx) => {
         val['key'] = idx+1;
         val['created_at'] = new Date(val['created_at']).toGMTString();
         return val;
      } );
      setRemarkStatusList(updatedList);
      setOriginalDataList(updatedList);
   }

   const [moduleOperationsForReadPermissionCheck, setModuleOperationsForReadPermissionCheck] = useState({});
   
     useEffect(() => {
      const user = getUser();
         if (user) {
           if (user?.acl_settings) {    
             setModuleOperationsForReadPermissionCheck(JSON.parse(user.acl_settings.module_operations));
           }
         }
     }, []);

   useEffect(() => {
      if(searchValue){
         setRemarkStatusList(
            remarkStatusList.filter((data) => data.remark.toLowerCase().includes(searchValue.trim().toLowerCase()))
         );
      }
      else {
         setRemarkStatusList(originalDataList);
      }
   }, [searchValue, remarkStatusList]);

   async function handleDeleteRemarkStatus(id){
      checkAuth(setToastProps, setShowToast)
      setIsMultiDelete(false);
      setEnableDeleteModal(true);
      setDeleteRemarkStatusId(id);
   }

   const handleSelectAll = () => {
      if (selectedRemarkStatus.length === remarkStatusList.length) {
          setSelectedRemarkStatus([]);
      } else {
          const allAclIds = remarkStatusList.map(acl => acl.id);
          setSelectedRemarkStatus(allAclIds);
      }
    };

    useEffect( () => {
      if (confirmDelete) {
          if (isMultiDelete) {
              postApiCall(API_REMARK_STATUS_DELETE, { remarkStatusIds: selectedRemarkStatus })
                  .then(onDeleteSuccess)
                  .catch(onDeleteFail);
          } else {
              postApiCall(API_REMARK_STATUS_DELETE, { remarkStatusIds: [deleteRemarkStatusId] })
                  .then(onDeleteSuccess)
                  .catch(onDeleteFail);
          }
      }
      }, [confirmDelete]);

   function onDeleteSuccess(resp) {
    toast.success("ACL Setting deleted successfully");
    let updatedList;
    if (isMultiDelete) {
        updatedList = remarkStatusList.filter(val => !selectedRemarkStatus.includes(val.id)).map((val, key) => {
            val['key'] = key + 1;
            return val;
        });
        setSelectedRemarkStatus([]);
    } else {
        updatedList = remarkStatusList.filter(val => val.id != deleteRemarkStatusId).map((val, key) => {
         val['key'] = key + 1;
         return val;
      });
    }
    setLoading(true);
    getApiCall(API_REMARK_STATUS_LIST)
      .then(onRemarkStatusListSuccess)
      .catch(onError)
      .finally(() => setLoading(false));
    setRemarkStatusList(updatedList);
    setEnableDeleteModal(false);
    setDeleteRemarkStatusId(undefined);
    setConfirmDelete(false);
 }

 function onDeleteFail(err) {
    if (typeof err !== 'object' && err.includes('TokenExpiredError')) {
       errorCheck(err, navigate, setToastProps, setShowToast)
    } else {
      toast.warning(`Unable to delete acl setting: ${err}`);
    }
 }


   if (loading) {
      return <Loader />
   }


   const RenderActionComponent = ({id}) => {
    const remarkStatusEditRoute = ROUTES.REMARKS.EDIT.replace(':id', id);
    return (
       <div className="flex align-items-center list-user-action">
         {(isSuperAdmin || loggedInUserACL[MODULE_ACL.REMARKS_STATUS]?.edit) && (
          <EditIcon linkTo={`/${remarkStatusEditRoute}`} />
         )}
          {' '}
         {(isSuperAdmin || loggedInUserACL?.[MODULE_ACL.REMARKS_STATUS]?.delete) &&
         selectedRemarkStatus.length === 0 && (
            <DeleteIcon
               handleCallback={() => handleDeleteRemarkStatus(id)}
            />
         )}
          {' '}
       </div>
    );

 }

   
   function onError(err) {
      if (typeof err !== 'object' && err.includes('TokenExpiredError')) {
         errorCheck(err, navigate, setToastProps, setShowToast)
      } else {
        console.log(err)
      }
   }

   const handleCreateButtonClick = () => {
      navigate(`/${ROUTES.REMARKS.ADD}`);
   } 


   const rowClassName = (data) => {
      return {
          'highlighted-row': selectedRemarkStatus.includes(data.id)
        };
    }

    const actionBodyTemplate = (rowData) => {
      return <RenderActionComponent id={rowData.id} />;
    };

  return(
     <>
       <div>
         <Row>
            <Col sm="12">
               <Card>
                  <Card.Header className="d-block justify-content-between">
                     <div className="header-title">
                        <h4 className="card-title">Remark Status List</h4>
                     </div>
                     {(isSuperAdmin || loggedInUserACL[MODULE_ACL.REMARKS_STATUS]?.add) && (
                        <button className="btn btn-primary ml-auto" onClick={handleCreateButtonClick}>Create Remark Status</button>
                     )}
                  </Card.Header>
                  <Card.Body className="px-0">
                     
                     <div className="table-responsive border-bottom my-3">
                     <div style={{display: "flex", alignItems: "flex-start", justifyContent: "flex-start"}}>
                         {((isSuperAdmin || loggedInUserACL?.[MODULE_ACL.REMARKS_STATUS]?.delete)) && (
                           <Button 
                              label="Delete Selected" 
                              onClick={handleMultiDelete} 
                              className="p-button-danger p-button-sm" 
                              style={{ marginBottom: '10px', marginLeft: '10px' }} 
                              disabled={selectedRemarkStatus.length === 0} 
                           />   
                         )}
                        {remarkStatusList.length > 0 &&
                           <Button 
                           label="Export Data" 
                           onClick={handleExport} 
                           className="p-button-active p-button-sm" 
                           style={{ marginBottom: '10px', marginLeft: '10px' }} 
                           disabled={buttonDisable} 
                        >
                           &nbsp;
                           {buttonDisable && (
                              <span className="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
                           )}
                        </Button>
                        }

                        <Form.Group style={{height: "45px"}}>
                           <Form.Control
                              style={{height: "50px", marginLeft: "10px", border: "1px solid #ced4da", fontSize: "15px", height: "45px"}}
                              placeholder = 'Search by Remark...'
                              type="text"
                              maxLength={100}
                              value={searchValue} 
                              onChange={(e) => setSearchValue(e.target.value)}
                              required
                           />
                        </Form.Group>
                        </div>
                        <div className="scroll-container">
                           <DataTable value={remarkStatusList} tableStyle={{ minWidth: '50rem' }} paginator rows={8} rowClassName={rowClassName}>
                           <Column 
                              header={<Checkbox 
                              checked={selectedRemarkStatus.length === remarkStatusList.length && remarkStatusList.length > 0} 
                              onChange={handleSelectAll} 
                              />} 
                              headerStyle={{ width: '3rem' }} 
                              body={(rowData) => (
                              <Checkbox 
                                 checked={selectedRemarkStatus.includes(rowData.id)} 
                                 onChange={() => handleCheckboxToggle(rowData.id)} 
                              />
                              )} 
                           />
                              <Column field="remark" filterField="Remark" header="Remark"></Column>
                              <Column field="status" filterField="Status" header="Status"></Column>
                              <Column field="created_at" header="Created Date" body={(rowData) =>
                                    new Date(rowData.created_at).toLocaleString("en-IN", {
                                       day: "2-digit",
                                       month: "short",
                                       year: "numeric",
                                       hour: "2-digit",
                                       minute: "2-digit",
                                       second: "2-digit",
                                    })
                                 }></Column>
                                 <Column field="created_by_user.username" header="Created By"></Column>
                              <Column header="Action" body={actionBodyTemplate} />
                           </DataTable>
                        </div>   
                     </div>

                  </Card.Body>
               </Card>
            </Col>
         </Row>
      </div>

      <RenderDeleteModal 
         show={enableDeleteModal} 
         setShow={setEnableDeleteModal} 
         setConfirmDelete={setConfirmDelete} 
         isMultiDelete={isMultiDelete} 
         clearSelectedData={() => setSelectedRemarkStatus([])}
      />

      {/* <ToastNotification show_toast={showToast} set_show_toast={setShowToast} {...toastProps} /> */}

     </>
  )

}

export default RemarkStatusList;